const COSTCO = 'Costco';

export { COSTCO };
